export default __webpack_public_path__ + "static/media/YTActive.417f41f2.svg";